import * as fbAnalytics from "./trackers/facebook";
import * as gaAnalytics from "./trackers/ga";

import getSession from "./getSession";
import * as events from "./events";

import dev, { isClient, isLocal } from "../utils/dev";
import { flattenObject, tryc, createCounter } from "../utils/utils";
import { B2B_BACKEND } from "..";

const eventOrderCounter = createCounter(0);

export const logEvent = async ({ category, action, infos, beacon = true }) => {
  const { id: sessionId, cinemapId, hostname, url } = getSession();

  try {
    if (!Object.values(events).includes(action))
      throw Error(`[Analytics] Unknown action type ${action}`);
    if (!action) throw Error("[Analytics] Missing action");
    if (!category) throw Error("[Analytics] Missing category");

    const eventOrder = eventOrderCounter();

    const postData = [
      new URL("logSessionEvent", B2B_BACKEND),
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          session_id: sessionId,
          category,
          action,
          infos: JSON.stringify(infos),
          event_order: eventOrder,
          keep_alive: beacon,
        }),
      },
    ];

    const trackCustomEventData = {
      category,
      action,
      label: JSON.stringify(infos),
      value: eventOrder,
      transport: beacon ? "beacon" : undefined,
    };

    if (isClient) {
      if (isLocal) {
        dev.console.warn("[Analytics-DEV] Redirect POST to console...");
        dev.console.log(...postData);
        dev.console.log(trackCustomEventData);
      } else {
        fetch(...postData);
        if (!window.ga)
          console.warn("[Analytics] GA is not activated in production");
        else gaAnalytics.track(trackCustomEventData);
      }

      await fbAnalytics.track(
        "logEvent",
        flattenObject({
          action: trackCustomEventData.action,
          category: trackCustomEventData.category,
          value: tryc(
            () => JSON.parse(trackCustomEventData.label),
            trackCustomEventData.label
          ),
          event_order: eventOrder,
          hostname,
          url,
          cinemap_id: cinemapId,
          session_id: sessionId,
        })
      );
    }

    return { ok: true, err: null };
  } catch (err) {
    console.error(err);
    return { ok: false, err };
  }
};

export * from "./events";
export default logEvent;
